import { useCallback, useState } from "react";
import { Box } from "@mui/material";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";
import { restrictToParentElement, restrictToVerticalAxis } from "@dnd-kit/modifiers";

import SortableItem from "./SortableItem";
import { dragListSx } from "./style";

const DragAndDropList = ({ handleDeleteLink, items, setItems, listKey, embedType }) => {
  const [isDragging, setIsDragging] = useState(false);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
  );

  const onDragStart = useCallback(() => setIsDragging(true), []);

  const onDragEnd = useCallback(
    ({ active, over }) => {
      setIsDragging(false);
      if (!over || active.id === over.id) return;
      const oldIndex = items.indexOf(active.id);
      const newIndex = items.indexOf(over.id);
      setItems(listKey, arrayMove(items, oldIndex, newIndex));
    },
    [items, setItems, listKey],
  );

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      modifiers={[restrictToVerticalAxis, restrictToParentElement]}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
    >
      <SortableContext items={items} strategy={verticalListSortingStrategy}>
        <Box sx={dragListSx}>
          {items.map((item, index) => (
            <SortableItem
              key={item}
              item={item}
              index={index}
              isDraggingAny={isDragging}
              handleDeleteLink={handleDeleteLink}
              embedType={embedType}
            />
          ))}
        </Box>
      </SortableContext>
    </DndContext>
  );
};

export default DragAndDropList;
